module.exports = __webpack_public_path__ + "static/media/person6.ee9f5541.jpg";